const generateForm03 = [
  {
    label: "อุปสมบท ณ คำสั่งมหาวิทยาลัยเลขที่",
    name: "university_no_ref",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "เมื่อวันที่",
    name: "university_date_ref",
    placeholder: "",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "",
    name: "",
    placeholder: "",
    type: "free-space",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 0, md: 0, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "",
    name: "",
    placeholder: "",
    type: "free-space",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 0, md: 0, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "อุปสมบท ณ พัทธสีมาวัด",
    name: "ordination_address",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "จังหวัด",
    name: "ordination_province",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "เขต/อำเภอ",
    name: "ordination_district",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "leave_type",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },

  {
    label: "แขวง/ตำบล",
    name: "ordination_district_sub",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ในวันที่",
    name: "ordination_date",
    placeholder: "",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "จำพรรษาอยู่ ณ วัด",
    name: "buddhist_lent_at",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "จังหวัด",
    name: "buddhist_lent_province",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "เขต/อำเภอ",
    name: "buddhist_lent_district",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "แขวง/ตำบล",
    name: "buddhist_lent_district_sub",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: true,
    titleRequired: "",
    disable: false,
    section: "information",
  },
];

export default generateForm03;
